import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {reducersState} from '../../redux/reducers';
import {logIn} from '../../redux/actions/user';
// @ts-ignore: TS2459 — we know it's there at runtime
import {SigninForm, SigninInfoSection, PaymentFooter} from '@PikaDoApp/pikado-web-dsm';
import SimpleLoader from '../../components/SimpleLoader/SimpleLoader';
import './SignIn.css';

const SignIn = () => {
  const dispatch = useDispatch();
  const isLoading: boolean = useSelector(
    (state: reducersState) => state.user.isLoadingRequest,
  );

  // Classera Auth URL
  const classeraAuthUrl =
    window.location.hostname.includes('staging') ||
    window.location.hostname.includes('localhost')
      ? 'https://me-stg.classera.com/AuthWithClassera?partnerCode=PIKADO&typeLogin=teacher'
      : 'https://me.classera.com/AuthWithClassera?partnerCode=PikaDo&typeLogin=teacher';

  const handleClasseraAuth = () => window.open(classeraAuthUrl, '_blank');

  const handleSignIn = async ({email, password}: {email: string; password: string}) => {
    dispatch(logIn(email, password));
  };

  const handleForgetPassword = () => {
    // TODO: Implement forgot password navigation
    console.log('Forgot password clicked');
  };

  const handleSignUpClick = () => {
    // TODO: Implement sign up navigation
    console.log('Sign up clicked');
  };

  return (
    <>
      <SimpleLoader isLoading={isLoading} title="Signing in..." />
      <div className="signin-main-container">
        <div className="signin-content-wrapper">
          <div className="signin-layout-container">
            <div className="signin-form-section">
              <SigninForm
                emailLabel="Email"
                emailPlaceholder="Enter your email"
                emailRequired
                hideNavigationElements={true}
                forgotPasswordText="Forgot Password?"
                logoTitleText="Sign in to your account"
                noAccountText="Don't have an account?"
                onForgotPassword={handleForgetPassword}
                onSignUpClick={handleSignUpClick}
                onSubmit={handleSignIn}
                passwordLabel="Password"
                passwordPlaceholder="Enter your password"
                passwordRequired
                signInButtonText="Sign In"
                signUpLinkText="Sign Up"
                classeraButtonText="Sign in with Classera"
                onClasseraClick={handleClasseraAuth}
              />
            </div>
            <div className="signin-info-section">

              <SigninInfoSection
                mainText="An AI-powered assistant helps English language teachers improve students' conversational skills in schools."
                secondaryText="Fifteen-minute daily exercises align with the school English curriculum, allowing students to complete them from home at any time under the full supervision of their teacher."
                />
            </div>
          </div>
          <PaymentFooter />
        </div>
      </div>
    </>
  );
};

export default SignIn;
